// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3oSmr","containerItemsCenter":"Skeleton_containerItemsCenter__1Dd6i"};